
import { useState, useEffect } from 'react';
import { cn } from '@/lib/utils';
import { UserMenu } from './UserMenu';
import { useAuth } from '@/contexts/AuthContext';
import { hasRole } from '@/utils/auth'; 
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Shield } from 'lucide-react';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { user, isAuthenticated } = useAuth();
  const isAdmin = hasRole(user, 'admin');
  const location = useLocation();
  const navigate = useNavigate();
  
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  const scrollToSection = (id: string) => {
    if (location.pathname === '/') {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(`/`);
      
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };
  
  const handleTestClick = () => {
    if (isAuthenticated) {
      scrollToSection('personality-test');
    } else {
      document.dispatchEvent(new CustomEvent('open-auth'));
    }
  };
  
  return (
    <header 
      className={cn(
        "fixed top-0 left-0 right-0 z-50 transition-all duration-300",
        isScrolled 
          ? "bg-background/80 backdrop-blur-md shadow-sm py-3" 
          : "bg-transparent py-5"
      )}
    >
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          <Link to="/" className="text-xl font-bold">
            <span className="text-primary">Career</span>Lens.ai
          </Link>
          
          <nav className="hidden md:flex items-center space-x-6">
            <button 
              onClick={() => scrollToSection('home')}
              className="text-muted-foreground hover:text-foreground transition-colors cursor-pointer"
            >
              Home
            </button>
            
            <button 
              onClick={handleTestClick}
              className="text-muted-foreground hover:text-foreground transition-colors cursor-pointer"
            >
              Test
            </button>
            
            <button 
              onClick={() => scrollToSection('future-careers')}
              className="text-muted-foreground hover:text-foreground transition-colors cursor-pointer"
            >
              Careers
            </button>
            
            <button 
              onClick={() => scrollToSection('pricing-section')}
              className="text-muted-foreground hover:text-foreground transition-colors cursor-pointer"
            >
              Pricing
            </button>
            
            <button 
              onClick={() => scrollToSection('about')}
              className="text-muted-foreground hover:text-foreground transition-colors cursor-pointer"
            >
              About
            </button>
            
            {isAdmin && (
              <Link to="/admin" className="flex items-center text-primary hover:text-primary/80 transition-colors">
                <Shield className="mr-1 h-4 w-4" />
                Admin
              </Link>
            )}
          </nav>
          
          <div className="flex items-center">
            <UserMenu />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
